import { useState, useEffect } from 'react';
import liff from "@line/liff";
import AppForm from './AppForm';
import LineCall from './LineCall';
import ModalWaiting from "../Components/ModalWaiting";

function LIFFHome(props) {
  const [userID, setUserID] = useState("");
  const [userName, setUserName] = useState("");
  const [viewMode, setViewMode] = useState(""); 
  const [waitingShow, setWaitingShow] = useState(true);

  useEffect(() => {
    // URLのクエリパラメータ（?params=linecall など）を取得
    const queries = new URLSearchParams(window.location.search);
    const queryParam = queries.get('params') || props.params;
    setViewMode(queryParam);

    // props.params に応じて LIFF ID を切り替え
    const liffId = props.params === "albumdigital" 
      ? "2009124484-uEehClUT" 
      : "2009168617-b0PqyOgy";

    liff.init({ liffId }).then(() => {
      if (!liff.isLoggedIn()) {
        liff.login();
      } else {
        liff.getProfile().then((profile) => {
          setUserID(profile.userId);
          setUserName(profile.displayName);
          setWaitingShow(false);
        });
      }
    }).catch(err => {
      console.error(err);
      setWaitingShow(false);
    });
  }, [props.params]);

  if (waitingShow) return <ModalWaiting show={true} />;

  return (
    <>
      {viewMode === "linecall" ? (
        <LineCall params={props.params} userID={userID} userName={userName} />
      ) : (
        <AppForm params={props.params} userID={userID} userName={userName} />
      )}
    </>
  );
}

export default LIFFHome;
